import { HiOutlinePaperAirplane } from "react-icons/hi";

export function ContactForm() {
    return (
        <div className="rounded-3xl border border-white/[0.08] bg-white/[0.08] p-8 backdrop-blur-[6px]">
            <div className="grid gap-4 md:grid-cols-2">
                <div>
                    <label className="mb-2 block text-xs uppercase tracking-wider text-white/70">
                        Name <span className="text-web-primary">*</span>
                    </label>
                    <input
                        className="h-10 w-full rounded-xl border border-white/10 bg-black/20 px-4 text-white outline-none"
                        type="text"
                    />
                </div>

                <div>
                    <label className="mb-2 block text-xs uppercase tracking-wider text-white/70">
                        Email <span className="text-web-primary">*</span>
                    </label>
                    <input
                        className="h-10 w-full rounded-xl border border-white/10 bg-black/20 px-4 text-white outline-none"
                        type="email"
                    />
                </div>

                <div>
                    <label className="mb-2 block text-xs uppercase tracking-wider text-white/70">
                        Phone
                    </label>
                    <input
                        className="h-10 w-full rounded-xl border border-white/10 bg-black/20 px-4 text-white outline-none"
                        type="text"
                    />
                </div>

                <div>
                    <label className="mb-2 block text-xs uppercase tracking-wider text-white/70">
                        Company
                    </label>
                    <input
                        className="h-10 w-full rounded-xl border border-white/10 bg-black/20 px-4 text-white outline-none"
                        type="text"
                    />
                </div>
            </div>

            <div className="mt-6">
                <label className="mb-2 block text-xs uppercase tracking-wider text-white/70">
                    Message / Use Case <span className="text-web-primary">*</span>
                </label>

                <textarea
                    rows={5}
                    className="w-full rounded-xl border border-white/10 bg-black/20 p-4 text-white outline-none"
                />
            </div>

            <div className="mt-6">
                <label className="mb-2 block text-xs uppercase tracking-wider text-white/70">
                    How did you hear about us?
                </label>

                <select className="h-10 w-full rounded-xl border border-white/10 bg-black/20 px-4 text-xs text-white outline-none">
                    <option value="">Select an option</option>
                    <option value="google">Google Search</option>
                    <option value="linkedin">LinkedIn</option>
                    <option value="instagram">Instagram</option>
                    <option value="facebook">Facebook</option>
                    <option value="youtube">YouTube</option>
                    <option value="friend">Friend / Referral</option>
                    <option value="customer">Existing Customer</option>
                    <option value="whatsapp">WhatsApp</option>
                    <option value="event">Event / Conference</option>
                    <option value="blog">Blog / Article</option>
                    <option value="other">Other</option>
                </select>
            </div>

            <button className="mt-6 flex h-10 w-full items-center justify-center gap-2 rounded-xl bg-web-primary text-lg font-medium text-black">
                <HiOutlinePaperAirplane className="rotate-90 text-xl" />
                Send message
            </button>

            <p className="mt-4 text-center text-xs text-white/50">
                We typically respond within 2 hours during business hours.
            </p>
        </div>
    );
}